import LandingContainer from "@/features/landing/containers/landing-container";
import { createFileRoute } from "@tanstack/react-router";

// Path inferred from file location: /
export const Route = createFileRoute("/")({
  component: LandingContainer,
});
